export const PAGES_MENU = [
  {
    path: 'pages',
    children: [
      {
        path: 'dashboard',
        data: {
          menu: {
            title: 'Dashboard',
            icon: 'glyphicon glyphicon-home',
            selected: false,
            expanded: false,
            order: 0,
          },
        },
      },
      // {
      //   path: 'quots',
      //   data: {
      //     menu: {
      //       title: 'Quotation',
      //       icon: 'ion-ios-filing',
      //       selected: false,
      //       expanded: false,
      //       order: 0
      //     }
      //   }
      // },

      // {
      //   path: 'estimateRep',
      //   data: {
      //     menu: {
      //       title: 'Estimate',
      //       icon: 'ion-ios-list-outline',
      //       selected: false,
      //       expanded: false,
      //       order: 1
      //     }
      //   }
      // },
      {
        path: 'masters',
        data: {
          menu: {
            title: 'Masters',
            icon: 'glyphicon glyphicon-edit',
            selected: false,
            expanded: false,
            order: 2,
          },
        },
        children: [
          {
            path: 'quotationlist',
            data: {
              menu: {
                title: 'Quotation',
              },
            },
          },
          {
            path: 'productmaster',
            data: {
              menu: {
                title: 'Product Master',
              },
            },
          },
          {
            path: 'VehicleSetupList',
            data: {
              menu: {
                title: 'Vehicle Setting',
              },
            },
          },
          {
            path: 'DivisionList',
            data: {
              menu: {
                title: 'Division',
              },
            },
          },
          {
            path: 'warehouse',
            data: {
              menu: {
                title: 'Warehouse',
              },
            },
          },
          {
            path: 'MechanicList',
            data: {
              menu: {
                title: 'Mechanic Info',
              },
            },
          },
          {
            path: 'SupervisorList',
            data: {
              menu: {
                title: 'Superviser Info',
              },
            },
          },
          {
            path: 'JobDescriptionList',
            data: {
              menu: {
                title: 'Job Description',
              },
            },
          },
          {
            path: 'CustomerList',
            data: {
              menu: {
                title: 'Customer',
              },
            },
          },
          {
            path: 'ProductList',
            data: {
              menu: {
                title: 'Vehicle Entry', //Product Details
              },
            },
          },
          {
            path: 'AmcList',
            data: {
              menu: {
                title: 'AMC',
              },
            },
          },
          {
            path: 'CallList',
            data: {
              menu: {
                title: 'Call Customer',
              },
            },
          },

          {
            path: 'sendbulkmessage',
            data: {
              menu: {
                title: 'Send Message',
              },
            },
          },
          {
            path: 'ModelwiseMappingTable',
            data: {
              menu: {
                title: 'Service Schedule',
              },
            },
          },
          {
            path: 'FreeServiceEntryTable',
            data: {
              menu: {
                title: 'Free Service Entry',
              },
            },
          },
          {
            path: 'AMCEntryTable',
            data: {
              menu: {
                title: 'AMC Entry',
              },
            },
          },
        ],
      },

      {
        path: 'inventory',
        data: {
          menu: {
            title: 'Inventory',
            icon: 'ion-ios-pricetags',
            selected: false,
            expanded: false,
            order: 3,
          },
        },
        children: [
          {
            path: 'JobCardLi',
            data: {
              menu: {
                title: 'Jobcard Open',
              },
            },
          },
          {
            path: 'dispatch',
            data: {
              menu: {
                title: 'Delivery Out',
              },
            },
          },
          {
            path: 'dispatchIn',
            data: {
              menu: {
                title: 'Delivery In',
              },
            },
          },
          {
            path: 'JobCardClosedList',
            data: {
              menu: {
                title: 'Jobcard Close',
              },
            },
          },
        ],
      },

      {
        path: 'userManager',
        data: {
          menu: {
            title: 'User Manager',
            icon: 'glyphicon glyphicon-user',
            selected: false,
            expanded: false,
            order: 5,
          },
        },
        children: [
          {
            path: 'userlist',
            data: {
              menu: {
                title: 'User List',
              },
            },
          },
          {
            path: 'password',
            data: {
              menu: {
                title: 'Change Password',
              },
            },
          },
        ],
      },
      {
        path: 'reports',
        data: {
          menu: {
            title: 'Reports',
            icon: 'glyphicon glyphicon-list',
            selected: false,
            expanded: false,
            order: 6,
          },
        },
        children: [
          // {
          //   path: 'quotationReport',
          //   data: {
          //     menu: { title: 'Message Report', parameter: 'MessageReport' },
          //   },
          // },
          // {
          //   path: 'quotationReport',
          //   data: {
          //     menu: { title: 'Quotation Report', parameter: 'QuotationReport' },
          //   },
          // },
          // {
          //   path: 'quotationReport',
          //   data: {
          //     menu: {
          //       title: 'Service History Report',
          //       parameter: 'serviceHistoryReport',
          //     },
          //   },
          // },
          // {
          //   path: 'deliveryReport',
          //   data: { menu: { title: 'Delivery Report' } },
          // },
          // { path: 'TRCReport', data: { menu: { title: 'TRC Report' } } },
          // // {
          // //   path: 'reports',
          // //   data: {
          // //     menu: {
          // //       title: 'JobCard Report',
          // //     }
          // //   }
          // // }
          // // { path: 'customerFollowupReport', data: { menu: { title: 'Customer Followup Report' } } },
          // // { path: 'modelwiseServiceStatusReport', data: { menu: { title: 'Modelwise Service Status Report' } } }
        ],
      },
      {
        path: 'report',
        data: {
          menu: {
            title: 'JobCard Report',
            icon: 'ion-ios-outline',
            selected: false,
            expanded: false,
            order: 1,
          },
        },
      },
    ],
  },
];
